module.exports = __webpack_public_path__ + "media/correct4.ab64afb9.mp3";